const colors = [
  '964746',
  '84b4d2',
  '63a04a',
  '2d5971',
  'bf5f73',
  'c19744',
  'c08867',
  'b2afd4',
  '6f446e',
  '442a27',
]

export const nivoLightColors = colors.map((item) => `#${item}`)
